import axios from "axios";
import { sysLang } from "contants/syslang";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectClientCountryCode, setClientCountryCode } from "store/master";

import { useAppDispatch } from "./app-hook";

const LangsKey: {
  [key: string]: string;
} = {
  TR: "tr",
  EN: "en",
  GB: "en",
  US: "en",
  TW: "zh-TW",
  HK: "zh-TW",
  CN: "zh-TW",
};

const languageDefault = localStorage.getItem("i18nLng");

export const useIP = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const dataCountryCode = useSelector(selectClientCountryCode);
  const handleLanguage = useCallback(async () => {
    if (languageDefault) {
      dispatch(setClientCountryCode(languageDefault || "tr"));
      i18n.changeLanguage(languageDefault || "tr");
      localStorage.setItem("syslang", (sysLang[languageDefault] || 16) + "");
      return;
    }

    try {
      const { data } = await axios.get("https://geolocation-db.com/json/");
      const countryCode = (data?.country_code as string)?.toUpperCase();
      const language = LangsKey[countryCode] || "tr";

      dispatch(setClientCountryCode(language));
      i18n.changeLanguage(language);
      localStorage.setItem("i18nLng", language);
      localStorage.setItem("syslang", (sysLang[language] || 16) + "");
    } catch {
      dispatch(setClientCountryCode("tr"));
      i18n.changeLanguage("tr");
      localStorage.setItem("i18nLng", "tr");
      localStorage.setItem("syslang", "16");
    }
  }, [i18n, dispatch]);

  const sysLangCurrent =
    sysLang[dataCountryCode] ||
    sysLang[localStorage.getItem("i18nLng") || "tr"] ||
    16;

  localStorage.setItem("syslang", sysLangCurrent + "");

  useEffect(() => {
    handleLanguage();
  }, [handleLanguage]);
};
